import React, {PureComponent} from 'react';

/**
  const D = () => <span>Desktop</span>
  const T = () => <span>Tablet</span>
  const M = () => <span>Mobile</span>

  const Animation = withBreakpoints({
    desktop: D,
    tablet: T,
    mobile: M
  })

  <Animation {...props} />

  The breakpoint is set to 992px width. You may find
  example on index.js where we import dynamically a lottie animation (LottiePS)
  component for desktop and an svg for mobile. The hoc controls when each
  component is going to be rendered. The timeout for debounced function
  is set to 150 ( equals 60 / 0.4 as maximum screen update frequency
  is 60 fps and we use an exact subdivision).

*/
const NOOP = () => null;

const withBreakpoints = ({
  mobile: Mobile = NOOP,
  // Small Hack here: When no tablet rules applied, mobile rules apply.
  tablet: Tablet = Mobile,
  desktop: Desktop = NOOP
}) =>
  class extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
      breakpoint: ''
    };
    }

    componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.onResize();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
      const {breakpoint} = this.state;
      const width = window.innerWidth;
      if (width <= 576) {
        if (breakpoint !== 'mobile') {
          this.setState({breakpoint: 'mobile'});
        }
      } else if (width <= 992) {
        if (breakpoint !== 'tablet') {
          this.setState({breakpoint: 'tablet'});
        }
      } else if (width > 992) {
        if (breakpoint !== 'desktop') {
          this.setState({breakpoint: 'desktop'});
        }
      }
    };

    render() {
      const {breakpoint} = this.state;

      let componentToReturn = <Desktop {...this.props} />;
      if (breakpoint === '') {
        componentToReturn = null;
      } else if (breakpoint === 'mobile') {
        componentToReturn = <Mobile {...this.props} />;
      } else if (breakpoint === 'tablet') {
        componentToReturn = <Tablet {...this.props} />;
      }
      return componentToReturn;
    }
  };
export default withBreakpoints;
